<dx-popup
  id="dialog-ajout-produit-complementaire"
  width="92vw"
  height="88vh"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [wrapperAttr]="{ class: 'produit-complementaire-ajout-popup' }"
  (onShowing)="onShowing()"
  [(visible)]="visible">

  <div *dxTemplate="let _ of 'title'" class="produit-complementaire-ajout-header">
    <div>
      <yo-icon icon="plus"></yo-icon> <strong> Ajouter des produits complémentaires</strong>
    </div>

    <div class="produit-complementaire-ajout-header-actions">
      <yo-button
        iconClass="fas fa-save"
        tooltip="Ajouter les produits au point de livraison"
        [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!propositionList().length"
        (onClick)="ajouter()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Annuler"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="fermer()">
      </yo-button>
    </div>
  </div>

  <section class="produit-complementaire-ajout-content">
    <div class="produit-complementaire-ajout-barre-outils">
      <yo-button
        iconClass="fas fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        label="Choisir des produits"
        (onClick)="openSelection()">
      </yo-button>
      <span class="produit-complementaire-compteur">{{ propositionList().length }} produit(s) à paramétrer</span>
    </div>

    <yo-produit-complementaire-grid
      [produitComplementaireList]="propositionList()"
      [pagingInterne]="true"
      noDataText="Cliquez sur « Choisir des produits » pour composer votre proposition"
      suppressionIconClass="fas fa-times"
      suppressionTooltip="Retirer de la proposition"
      (periodeClick)="openDialogPeriode($event)"
      (suppressionClick)="retirerDeLaProposition($event)"
      (jourClick)="toggleJour($event)">
    </yo-produit-complementaire-grid>
  </section>
</dx-popup>

<yo-dialog-selection-produit-complementaire
  [(visible)]="selectionVisible"
  [selectedIdList]="selectedIdList()"
  (selectionValidee)="onSelectionValidee($event)">
</yo-dialog-selection-produit-complementaire>

<yo-dialog-periode-conditionnement
  [(visible)]="dialogPeriodeVisible"
  [produit]="produitPeriode()"
  (periodeListChange)="onPeriodeListChange($event)">
</yo-dialog-periode-conditionnement>
